<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.erp.popup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table
        v-if="loadedData"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
              <th scope="col" class="border-0 pl-4">{{ $t('order.erp.popup.queryStartedAt') }}</th>
              <th scope="col" class="border-0" style="width: 300px;">{{ $t('order.erp.popup.action') }}</th>
              <th scope="col" class="border-0" style="width: 300px;">{{ $t('order.erp.popup.status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) of erpStatuses"
            :key="'erp-status-' + index">
              <td class="align-middle pl-4">
                {{ item.query_started_at }}
              </td>
              <td class="align-middle">
                {{ $t('order.erp.popup.actions.' + item.action ) }}
              </td>
              <td class="align-middle">
                <span
                  :class="{
                    'text-success': item.status === 'DONE',
                    'text-warning': item.status === 'WAITING',
                    'text-danger': item.status === 'ERROR',
                    'text-primary': item.status === 'QUEUED'
                  }">
                  {{ $t('order.erp.latestQueryStatus.' + item.status) }}
                </span>

                <template v-if="item.status === 'ERROR'">
                  <br>
                  <small class="text-danger">
                    <strong>{{ $t('order.erp.popup.errorMessage') }}:</strong>
                    <br>
                    {{ item.error_message }}
                  </small>
                </template>
              </td>
          </tr>
        </tbody>
      </table>
      <d-alert
        v-if="!loadedData"
        theme="light">
        {{ $t('ui.dataLoading') }}...
      </d-alert>
      <d-alert
        v-if="loadError"
        theme="warning">
        {{ $t('ui.errorOccuredDesc') }}...
      </d-alert>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'purchase-erp-integration-popup',
  props: [
    'purchaseID'
  ],
  data () {
    return {
      erpStatuses: [],
      loadedData: false,
      loadError: false
    };
  },
  mounted () {
    this.loadedData = false;

    FormUtils.loadAdditionalData(this, {
      endpoint: '/erp-optima/queries/items?where[resource_type]=PURCHASE&where[resource_id]=' + parseInt(this.purchaseID, 10) + '&return=get',
      method: 'get',
      loadedKey: 'loadedData',
      outputKey: 'erpStatuses',
      errorKey: 'loadError'
    });
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-purchase-erp-integration-popup');
    }
  }
}
</script>
